import { createAction } from 'typesafe-actions';
import { takeLatest, put } from 'redux-saga/effects';
import { PDP_PRODUCT_REVIEWS_IN_VIEWPORT } from 'features/product-reviews';
import { PDP_REVIEW_FORM_STEP_CHANGED, PDP_REVIEW_FORM_PUBLICATION_ERROR_SHOWN } from 'features/review-form';

/**
 * Событие должно срабатывать при появлении соответствующего блока во viewport /
 * при показе соответствующего шага модального окна написания отзыва
 *
 * @see https://docs.google.com/document/d/1vAT_kS09tM_69q5YshNF9o88nh3O1n17Tmt2nKdd8gw/edit#heading=h.5v1lvbuc8u55
 * @see https://docs.google.com/document/d/1vAT_kS09tM_69q5YshNF9o88nh3O1n17Tmt2nKdd8gw/edit#heading=h.dvlnfwuiw7mn
 */
export const gaBlockImpression = createAction(
  'GA:blockImpression',
  (params: {
    elementBlock: 'reviewsBlock' | 'reviewModalWindow'; // блок, в котором расположен элемент
    elementName: string; // условное обозначение блока
    elementText: string; // текст в блоке
  }) =>
    ({
      ...params,
      elementType: 'block',
    }) as const,
)();

enum StepNames {
  Step1 = 'Product review',
  Step2 = Step1,
  Step3 = 'Recommendation',
  Step4 = 'Term of use',
  Step5 = 'Review',
  Step6 = 'Product Photo',
  Step7 = 'Place of purchase',
  Step8 = 'Your data',
  Step9 = 'Almost done',
  Step10 = 'Thanks',
}

export function* runGaBlockImpressionDetector() {
  yield takeLatest(PDP_PRODUCT_REVIEWS_IN_VIEWPORT, function* putGaBlockImpression() {
    yield put(
      gaBlockImpression({
        elementBlock: 'reviewsBlock',

        elementName: 'Reviews',
        elementText: 'Отзывы',
      }),
    );
  });

  yield takeLatest(
    PDP_REVIEW_FORM_STEP_CHANGED,
    function* putGaBlockImpression({ payload }: ReturnType<typeof PDP_REVIEW_FORM_STEP_CHANGED>) {
      yield put(
        gaBlockImpression({
          elementBlock: 'reviewModalWindow',

          elementName: `${payload.newStep} / ${StepNames[payload.newStep]}`,
          elementText: payload.newStepRuName,
        }),
      );
    },
  );

  yield takeLatest(
    PDP_REVIEW_FORM_PUBLICATION_ERROR_SHOWN,
    function* putGaBlockImpression({ payload }: ReturnType<typeof PDP_REVIEW_FORM_PUBLICATION_ERROR_SHOWN>) {
      yield put(
        gaBlockImpression({
          elementBlock: 'reviewModalWindow',

          elementName: 'error',
          elementText: payload.ruText,
        }),
      );
    },
  );
}
